/* global google */
import _ from 'lodash';

function inNYC({address_components}) {
  return address_components
    .filter(a => a.types.includes('administrative_area_level_2'))
    .filter(n => n.long_name.match(/(Kings|Queens|New York|Richmond|Bronx) County/))
    .length;
}

function inBoro(addressParts, boroName) {
  return Boolean(_.find(addressParts, a => a.long_name.match(boroName)));
}

function rejectForNoResults(reject) {
  reject({error: {message: 'No Results Found'}});
}

function rejectForBadStatus(reject, status) {
  reject({error: {message: `Could not look up addres because ${status}`}});
}

function rejectForMultipleLoctions(reject, results) {
  reject({
    error: {
      message: 'Did you mean...',
      locations: results.map(result => {
        return {
          address: result.formatted_address,
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng(),
          isBronx: inBoro(result.address_components, 'Bronx'),
          isBrooklyn: inBoro(result.address_components, 'Kings')
        };
      })}
  });
}

function rejectForOutOfBounds(reject) {
  reject({error: {message: 'Please enter a New York City address.'}});
}

export default function geocode(address) {
  return new Promise((resolve, reject) => {
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      address,
      componentRestrictions: {
        administrativeArea: 'NY'
      }
    }, function(results, status) {
      if (results.length === 0) {
        rejectForNoResults(reject);
      } else if (status !== 'OK') {
        rejectForBadStatus(reject, status);
      } else if (results.length > 1) {
        rejectForMultipleLoctions(reject, results);
      } else if (!inNYC(results[0])) {
        rejectForOutOfBounds(reject);
      } else {
        resolve({
          address: results[0].formatted_address,
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
          isBronx: inBoro(results[0].address_components, 'Bronx'),
          isBrooklyn: inBoro(results[0].address_components, 'Kings')
        });
      }
    });
  });
}



// WEBPACK FOOTER //
// ./app/src/js/lib/geocoding.js